import {
  ApplicationKeyDecryption,
  type DecryptionStrategy,
  NameDecryption,
  StreamKeyDecryption,
  WhiteboardDecryption,
} from 'features/e2ee/core/decryption-strategies';
import { E2EEWhiteboardManager } from 'features/e2ee/E2EEWhiteboardManager';
import type { EncryptedData } from 'features/e2ee/types';

export class DecryptionStrategySelector {
  private static strategies: DecryptionStrategy[] = [];

  static init(whiteboard: E2EEWhiteboardManager): void {
    this.strategies = [
      new StreamKeyDecryption(),
      new ApplicationKeyDecryption(),
      new NameDecryption(),
      new WhiteboardDecryption(whiteboard),
    ];
  }

  static selectFor(data: EncryptedData): DecryptionStrategy[] {
    return this.strategies.filter((strategy) => strategy.canHandle(data));
  }
}
